import { apiCall } from ".";
import { UpdatePasswordInterface, UpdateProfileInterface } from "../interfaces/profile";

export const updateUserPasswordApi = (payload: UpdatePasswordInterface) => {
  return apiCall(true).post("/user/change-password", payload);
};

export const updateUserProfileApi = (payload: UpdateProfileInterface) => {
  return apiCall(true).post("/user/update-profile", payload);
};

export const getUserProfileApi = () => {
  return apiCall(true).get("/user");
};
